import { BaseModal } from './BaseModal'
import { CONFIG } from '../../constants/config'
import { VALIDGUESSES } from '../../constants/validGuesses'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const ValidGuessesModal = ({ isOpen, handleClose }: Props) => {
  const listWord = (word: string) => {
    return <li key={word}>{word}</li>
  }

  return (
    <BaseModal
      title={'The valid ' + CONFIG.wordLength + ' letter words in '+ CONFIG.language + ' are:'}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div>
        <ul>{VALIDGUESSES.map((x) => listWord(x))}</ul>
      </div>
    </BaseModal>
  )
}
